<template>
  <v-badge
    :content="scoreThreshold + '%'"
    :value="isScoreThresholdToggleEnabled && scoreThreshold > 0"
    :color="playlist.default_color"
    overlap
    left
    >
    <v-img v-if="thumbnail" :src="moduleBulb.bulb.thumbnail"></v-img>
    <v-icon v-else-if="isLMB">mdi-video-plus</v-icon>
    <v-icon v-else>mdi-play-circle</v-icon>
  </v-badge>
</template>

<script>

import {
  mapState,
} from 'vuex';
import _ from 'lodash';

export default {
  name: 'ScoreTresholdBadge',
  props: {
    isScoreThresholdToggleEnabled: {
      type: Boolean,
      default: false,
    },
    scoreThreshold: {
      type: [Number, Boolean],
    },
    thumbnail: {
      type: Boolean,
      default: false,
    },
    moduleBulb: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapState([
      'playlist',
    ]),
    isLMB() {
      return _.get(this, 'moduleBulb.bulb.lmbId', false);
    },
  },
};
</script>
